module.exports = __webpack_public_path__ + "files/2d1b9beb83832624a641959f8d669db5.png";